export default {
  mapboxToken: 'pk.eyJ1Ijoic2NobWVpYyIsImEiOiJjajFwbG1pNHAwMDIwMzJrNWxlb2NuNG0zIn0.6wfVDEx1kiUwnzvUFa-bVg',
  locationIQToken: '920e33cb4b1c92'
}
